import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import AutoReload from './component/AutoReload';
import ErrorBoundary from './component/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Sample Redux store
const store = createStore(() => ({
  birds: [
    {
      name: 'robin',
      views: 1
    }
  ]
}));

// Password & env platform check
const ROOT_PASSWORD = 'Tg780424'; // Change this
const isDevPlatform = process.env.REACT_APP_PLATFORM != 'production';

// Auth wrapper for development only
function AuthWrapper({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const today = new Date().toDateString();
    const loginDate = localStorage.getItem('loginDate');

    if (loginDate === today) {
      setIsAuthenticated(true);
    } else {
      let password;
      while (true) {
        password = prompt("Enter password:");
        if (password == null) {
          alert('Login cancelled. Reload the page to try again.');
          break;
        }
        if (password == ROOT_PASSWORD) {
          localStorage.setItem('loginDate', today);
          setIsAuthenticated(true);
          break;
        } else {
          alert('Incorrect password. Try again.');
        }
      }
    }
  }, []);

  if (!isAuthenticated) return null;
  return children;
}

// App content
const AppContent = (
  <ErrorBoundary>
    <Provider store={store}>
      <AutoReload />
      <App />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Provider>
  </ErrorBoundary>
);

// Render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  isDevPlatform ? <AuthWrapper>{AppContent}</AuthWrapper> : AppContent
);
